import { reactive } from 'vue';

const eventBus = reactive(new EventTarget());

export default eventBus;